export default (dateString) => {
    const timezoneName = 'America/Los_Angeles';
    return new Date(dateString).toLocaleString("en-US", {timeZone: timezoneName});
};